<template>
  <el-container class="container">
    <div class="navbar-brand animated fadeIn slow">
      <a href="https://510.ventures" class="main-logo" title="510 Ventures">
        <ventures-logo></ventures-logo>
      </a>
      <logo-divider v-if="logo != 'ventures'"></logo-divider>
      <a href="#home" class="page-logo" title="Scroll to the top" @click="scroll">
        <elements-logo v-if="logo == 'elements'"></elements-logo>
        <team-logo v-if="logo == 'team'"></team-logo>
        <investments-logo v-if="logo == 'investments'"></investments-logo>
        <lab-logo v-if="logo == 'lab'"></lab-logo>
        <rwanda-logo v-if="logo == 'rwanda'"></rwanda-logo>
        <leap-logo v-if="logo == 'leap'"></leap-logo>
      </a>
    </div>
  </el-container>
</template>

<script>
import { global } from '../mixins/global';

export default {
  name: 'logo-loader',
  mixins: [global],
  computed: {
    logo() {
      if (this.$route.path == '/rwanda' && this.site == 'investments') {
        return 'rwanda';
      } else {
        return this.site;
      }
    }
  },
  methods: {
    scroll() {
      const hashed = '#home';
      this.$scrollTo(hashed);
      window.location.hash = hashed;
    }
  },
  components: {
    ElementsLogo: () => import('./logos/ElementsLogo'),
    TeamLogo: () => import('./logos/TeamLogo'),
    VenturesLogo: () => import('./logos/VenturesLogo'),
    InvestmentsLogo: () => import('./logos/InvestmentsLogo'),
    LogoDivider: () => import('./logos/LogoDivider'),
    LabLogo: () => import('./logos/LabLogo'),
    RwandaLogo: () => import('./logos/RwandaLogo'),
    LeapLogo: () => import('./logos/LeapLogo')
  }
};
</script>
